import { whyPvolve } from '@/scripts/optional/section-video-with-accordion';

window.addEventListener('DOMContentLoaded', () => {
    whyPvolve().initAccordion();
});
